/**
 * PlayerPageHeader - Feature-gated player header with key indicators
 *
 * Exports the main PlayerPageHeader component and supporting types/utilities.
 * The header displays player identity info and 5 key indicator tiles.
 * @example
 * ```tsx
 * import PlayerPageHeader from "@/features/player-detail/components/organisms/PlayerPageHeader";
 *
 * <PlayerPageHeader player={playerData} loading={isLoading} />
 * ```
 */

import PlayerPageHeaderContainer from "./PlayerPageHeaderContainer";

export default PlayerPageHeaderContainer;

// Export types for external use
export type {
  IndicatorMetricType,
  PlayerPageHeaderContainerProps,
  ValuationStatus,
} from "@/features/player-detail/utils/playerPageHeaderTypes";

// Export constants for external use
export {
  EMPTY_VALUE_PLACEHOLDER,
  getIndicatorConfig,
  getValuationBadgeAction,
  INDICATOR_CONFIGS,
} from "@/features/player-detail/utils/playerPageHeaderConstants";

// Export utilities for external use
export {
  extractIndicatorData,
  extractPlayerIdentityData,
  formatCurrencyMillions,
  formatTransferValueRange,
} from "@/features/player-detail/utils/playerPageHeaderUtils";
